import React from "react";
import { useSelector } from "react-redux";
import moment from "moment-timezone";

import { IColum } from "../../../../../utils/copyToClipboardInXlsFormat";
import { Table } from "../../../../../components/ui";

const NUMBER_OF_NEW_PURCHASES_BY_MONTHS_COLUMNS: Array<IColum> = [
  {
    by: "month",
    title: "Month",
    path: "month",
  },
  {
    by: "numberOfPurchases",
    title: "Number of Purchases",
    path: "numberOfPurchases",
  },
];

const NumberOfNewPurchasesByMonths: React.FC = () => {
  const { data, loading } = useSelector(
    (state) => state.financials.passersStats.passedSubscription
  );

  const newPurchasesByMonths = new Map();
  data.passedSubscriptionPurchaseDate.forEach((item) => {
    const date = moment(item.purchase_date).tz("America/Chicago").format("YYYY-MMMM");
    if (newPurchasesByMonths.has(date)) {
      newPurchasesByMonths.set(date, newPurchasesByMonths.get(date) + 1);
    } else {
      newPurchasesByMonths.set(date, 1);
    }
  });

  const newPurchasesByMonthsArray = Array.from(newPurchasesByMonths.entries()).map(
    ([month, numberOfPurchases]) => ({
      month,
      numberOfPurchases,
    })
  );

  return (
    <div>
      <Table
        csv_table_name="Number of new purchases by months"
        theadTitle="Number of new purchases by months"
        columns={NUMBER_OF_NEW_PURCHASES_BY_MONTHS_COLUMNS}
        data={newPurchasesByMonthsArray}
        loading={loading}
        extractKey={(row) => row.month}
        isDownloadable
        noResultsMessage=""
      />
    </div>
  );
};

export default NumberOfNewPurchasesByMonths;
